export default function ({url, headers, method, body, handleSuccess, handleStatus, form}) {
  (async () => {
    // включаем спинер
    if (this) this['toggleLoading']();
    // формируем header
    let token = document.cookie.split(';').map(el => el.trim().split('=')).filter(el => el[0] === 'token');
    token = token && token.length
      ? token[0][1]
      : '';
    if (!token.length) this.changePage({name: 'AuthPage'});
    headers = headers
      ? headers
      : {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      };
    if (form) headers = {'Authorization': `Bearer ${token}`};
    // fetch
    const response = await fetch(url, {
      headers: headers,
      method,
      body
    });
    // json
    if (response.status === 500) {
      alert('Что-то пошло не так...');
      this['toggleLoading']();
      return
    }
    const json = await response.json();
    // обработка ошибок для всех запросов
    const handleError = function () {
      switch (response.status) {
        case 401:
          this.$data.inputRoute = this.$route.path;
          this.changePage({name: 'AuthPage'});
          break;
        case 404:
          break;
        default:
          break;
      }
    };
    // уникальная обработка для определённых статусов
    if (handleStatus && handleStatus[response.status]) (() => handleStatus[response.status](json))();
    // обрабатываем или колбек success или оишбки
    response.ok
      ? handleSuccess(json)
      : handleError.bind(this)(response, json);
    // отключаем спинер
    if (this) this['toggleLoading']();
  })()
}
